module.exports = __webpack_public_path__ + "static/chime-d4dbb85e12c2dec6da799ccd4378bace.mp3";